import React, { useState } from 'react';
import { useInView } from "react-intersection-observer";
import "../styles/aboutus.css";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { Slide } from '@mui/material';

const About = () => {
  const [formData, setFormData] = useState({
    emri: "",
    emaili: "",
    website: "",
    nrTelefonit: "",
    mesazhi: "",
  });

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://d3ejxze7429gw1.cloudfront.net/submit-form", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        setSnackbarMessage("Form submitted successfully!");
        setSnackbarSeverity("success");
      } else {
        setSnackbarMessage(result.message || "Failed to submit form.");
        setSnackbarSeverity("error");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setSnackbarMessage("An error occurred. Please try again.");
      setSnackbarSeverity("error");
    } finally {
      setSnackbarOpen(true);
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarOpen(false);
  };

  const [aboutRef, aboutInView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [expertRef, expertInView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [getInTouchRef, getInTouchInView] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [b2bRef, b2bInView] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [usaRef, usaInView] = useInView({ triggerOnce: true, threshold: 0.1 });


  return (
    <div>
      {/* Hero Section */}
      <div
        className={`about-container ${aboutInView ? "fade-in" : ""}`}
        ref={aboutRef}
      >
        <div className="overlay"></div>
        <div className="about-content">
          <h1 className="about-title">Rreth Nesh</h1>
          <p className="about-text">
            Themeluar në vitin 2021, Ronni Ceramics ka qenë një shtytje e madhe në
            industrinë e qeramikës në Kosovë, duke shërbyer nevojat e ndryshme të
            arkitektëve, dizajnerëve të brendshëm dhe pronarëve shtëpiash.
            Përkushtimi ynë ndaj inovacionit dhe përmirësimit të vazhdueshëm na ka
            fituar vlerësimin si një nga ofruesit potencial të pllakave qeramike
            dhe produkteve sanitare në rajon.
          </p>
        </div>
      </div>

      {/* Expert Section */}
      <div
        className={`expert-section ${expertInView ? "slide-in-left" : ""}`}
        ref={expertRef}
      >
        <div className="expert-image">
          <img src="/images/foto3.png" alt="Tile Sample" />
        </div>
        <div className="expert-text">
          <h3 className="expert-subtitle">🔸 ZBULONI ELEGANCËN NË PRODUKTE</h3>
          <h2 className="expert-title">Vlersuar nga ekspertë</h2>
          <p className="expert-description">
            Përkushtimi i Ronni Ceramics për cilësinë dhe dizajnin dallohet në
            çdo pllakë që ofrohet. Me Ronniceramics, gjeni përpjesëtimin e
            përsosur të stilit dhe funksionalitetit e stilit jetesës.
          </p>
          <div className="expert-small-image">
            <img src="/images/foto7.png" alt="Installation Process" />
          </div>
        </div>
      </div>

       {/* B2B Partnership Section */}
       <div
                className={`b2b-section ${b2bInView ? "slide-in-right" : ""}`}
                ref={b2bRef}
            >
                <div className="b2b-text">
                    <h3 className="b2b-subtitle">🤝 Partneritete B2B</h3>
                    <h2 className="b2b-title">Bashkëpunime Strategjike</h2>
                    <p className="b2b-description">
                        Ronni Ceramics ofron partneritete të dedikuara për bizneset që kërkojnë
                        bashkëpunim afatgjatë dhe sasi të mëdha. Ne punojmë ekskluzivisht me
                        korporata të mëdha ose me porosi që tejkalojnë 1500m². Ky kusht siguron
                        një bashkëpunim efikas dhe të përkushtuar, duke garantuar cilësi dhe
                        shërbim të nivelit të lartë për çdo projekt madhor.
                    </p>
                </div>
                <div className="b2b-image">
                    <img src="/images/foto1.1.jpeg" alt="B2B Partnership" />
                </div>
            </div>

             {/* USA Compliance Section */}
             <div
                className={`usa-section ${usaInView ? "slide-in-left" : ""}`}
                ref={usaRef}
            >
                <div className="usa-image">
                    <img src="/images/foto2.2.jpeg" alt="USA Flag" />
                </div>
                <div className="usa-text">
                    <h3 className="usa-subtitle">🇺🇸 Standarde Amerikane</h3>
                    <h2 className="usa-title">Materiale të Certifikuara</h2>
                    <p className="usa-description">
                        Çdo pllakë qeramike e Ronni Ceramics është prodhuar me materiale që plotësojnë
                        standardet e pranuara nga Shtetet e Bashkuara të Amerikës. Ne ofrojmë mundësinë
                        që çdo blerje të përgatitet dhe paketohet sipas kërkesave specifike për tregun
                        amerikan, duke siguruar cilësi dhe pajtueshmëri të garantuar.
                    </p>
                </div>
            </div>


      {/* Get in Touch Section */}
      <section
        className={`get-in-touch-section ${getInTouchInView ? "slide-in-right" : ""}`}
        ref={getInTouchRef}
      >
        <div className="get-in-touch-container">
      <form onSubmit={handleSubmit}>
        <h3>Na Kontaktoni</h3>
        <div className="input-group">
          <input
            type="text"
            name="emri"
            placeholder="Emri"
            value={formData.emri}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="emaili"
            placeholder="E-Mail"
            value={formData.emaili}
            onChange={handleChange}
            required
          />
        </div>

        <div className="input-group">
          <input
            type="text"
            name="nrTelefonit"
            placeholder="Numri i telefonit"
            value={formData.nrTelefonit}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="website"
            placeholder="Faqja juaj e internetit"
            value={formData.website}
            onChange={handleChange}
          />
        </div>

        <textarea
          name="mesazhi"
          placeholder="Mesazhi juaj këtu"
          value={formData.mesazhi}
          onChange={handleChange}
          required
        ></textarea>

        <button type="submit" className="get-in-touch-button">
          PARAQISNI TANI
        </button>
      </form>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        TransitionComponent={Slide}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
 
   

          <div className="get-in-touch-info">
            <div className="get-in-touch-box">
              <i className="fas fa-map-marker-alt"></i>
              <div>
                <h3>Lokacioni</h3>
                <p>
                  Objekti BK Center (Kati 1),<br />
                  Rr. "Ismail Raka" - Kaçanik 71000
                </p>
              </div>
            </div>

            <div className="get-in-touch-box">
              <i className="fas fa-envelope"></i>
              <div>
                <h3>Emaili</h3>
                <p>roniceramics@gmail.com</p>
              </div>
            </div>

            <div className="get-in-touch-box">
              <i className="fas fa-phone-alt"></i>
              <div>
                <h3>Na Thirrni</h3>
                <p>
                  +38344555951<br />
                  +38344124889
                </p>
              </div>
            </div>
          </div>

          <div className="get-in-touch-image">
            <img src="/images/foto6.png" alt="Modern Kitchen" />
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;